import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const GardeningKnowHow: Site = {
  id: 'gardeningknowhow',
  logo: 'svg/gardeningknowhow.svg',
  label: 'Gardening Know How',
  analyticsName: 'gardeningknowhow',
  hostname: 'gardeningknowhow.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
